import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { IconComponent } from '@shared-lib/components/icon/icon.component';
import { ProgressBarComponent } from '@shared-lib/components/progress-bar/progress-bar.component';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'cp-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ProgressBarComponent, ButtonModule, IconComponent],
})
export class StepperComponent {
  @Input() progress = 0;
  @Input() hideProgressBar = false;
  @Input() loading = false;
  @Input() forwardButtonEnabled = false;
  @Input() showForwardButtonIcon = true;
  @Input() forwardButtonLabel = 'Continue';
  @Input() showSkipButton = false;
  @Input() hideBackButton = false;
  @Input() showBackButtonIcon = true;
  @Input() backButtonLabel: string;

  @Output() back = new EventEmitter<void>();
  @Output() forward = new EventEmitter<void>();
  @Output() disabledForward = new EventEmitter<void>();

  goForward(): void {
    if (this.forwardButtonEnabled && !this.loading) {
      this.forward.emit();
    } else {
      this.disabledForward.emit();
    }
  }

  goBack(): void {
    this.back.emit();
  }
}
